// extracted by mini-css-extract-plugin
export default {"labelInputBox":"labelInputBox-F0jhR2","focus":"focus-u8th8T","label":"label-OgGs4d","labelInput":"labelInput-rCgzNu"};